import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { ILeaderboard } from 'src/reducers/leaderboardSlice';
import styles from './Leaderboard.module.scss';
import cx from 'classnames';
interface ProfileStatisticsChartCProps extends ILeaderboard {
  pieChartContainerClass?: string;
}

const ProfileStatisticsChart: React.FC<ProfileStatisticsChartCProps> = props => {
  const { pieChartContainerClass, promiseCount } = props;

  const data = [
    {
      name: 'PTPs yet to mature',
      y: promiseCount?.promiseYetToMature || 0,
      value: promiseCount?.promiseYetToMature || 0,
      fill: '#3B86F6'
    },
    {
      name: 'Promises Broken',
      y: 0,
      value: 0,
      fill: '#FF8042'
    },
    {
      name: 'Promises Fulfilled',
      y: promiseCount?.promiseFulfilled || 0,
      value: promiseCount?.promiseFulfilled || 0,
      fill: '#60D8B3'
    },
    {
      name: 'Promises Broken',
      y: promiseCount?.promiseBroken || 0,
      value: promiseCount?.promiseBroken || 0,
      fill: '#FF8042'
    }
  ];
  const dateLabel =
    (promiseCount?.promiseBroken || 0) +
    (promiseCount?.promiseFulfilled || 0) +
    (promiseCount?.promiseYetToMature || 0);

  const options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      style: {
        fontFamily: 'Inter'
      },
      renderTo: 'container',
      height: 183,
      width: 400
    },
    credits: {
      enabled: false
    },
    title: {
      text: `<div class='${styles.chartTitleContainer}'>${dateLabel}</div>`,
      align: 'center',
      verticalAlign: 'middle'
    },
    tooltip: {
      pointFormat: `<b class='${styles.tooltip}'>{point.percentage:.1f}%</b>`
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    plotOptions: {
      pie: {
        size: 120,
        dataLabels: {
          enabled: true,
          align: 'left',
          format: `
                  <div class=${styles.gray}>{point.name}</div>
                  <div>{point.value}
                </div>`,
          useHTML: true,
          distance: 10,
          filter: {
            property: 'percentage',
            operator: '>',
            value: 0
          }
        }
      }
    },
    series: [
      {
        type: 'pie',
        name: 'CashEarned',
        innerSize: '70%',
        data
      }
    ]
  };

  return (
    <>
      <div className={cx(styles.pieChart, pieChartContainerClass)}>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </>
  );
};

export default ProfileStatisticsChart;
